class EventEmitter {
    _events = {};
    on(name, fn) {
        this._events[name] = this._events[name] || [];
        this._events[name].unshift(fn);
    }
    off(name, fn) {
        if (this.has(name)) {
            const index = this._events[name].indexOf(fn);
            if (index != -1) {
                this._events[name].splice(index, 1);
            }
        }
    }
    has(name) {
        if (name in this._events && this._events[name].length != 0) {
            return true;
        }
        return false;
    }
    once(name, fn) {
        const self = this;
        const once = function (args) {
            self.off(name, once);
            if (typeof args !== "undefined") {
                fn(args);
            }
            else {
                fn();
            }
        };
        this.on(name, once);
    }
    ;
    emit(name, data) {
        if (this.has(name)) {
            for (let i = this._events[name].length - 1; i >= 0; i--) {
                if (typeof data !== "undefined") {
                    this._events[name][i](data);
                }
                else {
                    this._events[name][i]();
                }
            }
        }
    }
    ;
    destroy() {
        for (const name in this._events) {
            this._events[name] = null;
        }
        this._events = null;
    }
    ;
}
export default EventEmitter;
